<template>
  <div class="brand-menu">
    <div class="brand-content">
      <div class="close clearfix">
        <img
          src="https://s-test.kcimg.cn/topic/images/2021-annualmeeting/simple_close.png"
          @click="handleClose"
        />
      </div>
      <div class="city-menu">
        <div
          v-for="(item, index) in list"
          :key="index"
          :class="['item', item.id === Number(cityId) ? 'active-item' : '']"
          @click="goBrandDetail(item)"
        >
          {{ item.val }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { lineArr } from '../data/index.js'
export default {
  name: 'cityBox',
  props: {},
  mounted () {
    this.cityId = this.$route.query.id
    this.cityname = this.$route.query.cityname
  },
  data () {
    return {
      list: lineArr,
      cityId: '',
      cityname: ''
    }
  },
  methods: {
    handleClose () {
      this.$router.push({
        path: '/cityHome',
        query: { id: this.cityId, cityname: this.cityname }
      })
    },
    // 去品牌详情页
    goBrandDetail (item) {
      this.$router.push({
        path: '/cityHome',
        query: { id: item.id, cityname: item.val }
      })
    }
  }
}
</script>

<style scoped lang="less">
.brand-menu {
  z-index: 1001;
  background: #030c43;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  .brand-content {
    width: 750px;
    margin: 0 auto;
    box-sizing: border-box;
    padding: 20px;
  }
  .close img {
    cursor: pointer;
    float: right;
    display: block;
    width: 80px;
    height: 80px;
  }
  .city-menu {
    margin-top: 20px;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    .item {
      overflow: hidden;
      cursor: pointer;
      width: 160px;
      height: 70px;
      line-height: 70px;
      font-size: 26px;
      font-weight: 500;
      color: #ffffff;
      text-align: center;
      background: url(https://s-test.kcimg.cn/topic/images/2021-jiefangj6x/city-back.png)
        no-repeat 50% 50%;
      margin-bottom: 40px;
      margin-right: 20px;
      &:nth-of-type(4n) {
        margin-right: 0;
      }
    }
    .active-item {
      color: #feef43;
    }
  }
  .slogan {
    position: absolute;
    left: 50%;
    bottom: 80px;
    transform: translate(-50%, 0);
    display: block;
    width: 564px;
    height: 102px;
  }
}
</style>
